import {Component, Inject, OnInit} from '@angular/core';
import {NgbCarouselConfig, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorageService} from 'ngx-webstorage';
import {LanguageService} from '../../services/language.service';
import { PublicSaleableItemResourceService } from '../../../../core/Backend/sales-backend/services';
import { HmnzItemCategory, HmnzPublicSaleableItem } from '../../../../core/Backend/sales-backend/models';
import { Meta } from '@angular/platform-browser';
import { updateMetaTags } from '../../services/meta-utils';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  showNavigationArrows = false;
  showNavigationIndicators = true;
  currentLang: string;
  topSalableItems: HmnzPublicSaleableItem[];
  categories: HmnzItemCategory[]; 
  activeId = 'slide-0';
  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      900: {
        items: 1
      }
    },
    nav: false
  };
  selectedTab = 'company';

  constructor(
    @Inject(DOCUMENT) public document: Document,
    private router: Router,
    private meta: Meta,
    public publicSaleableItemResourceService: PublicSaleableItemResourceService,
    private langService: LanguageService,
    public translate: TranslateService,
    private modalService: NgbModal,
    public localStorageService: LocalStorageService,
    config: NgbCarouselConfig) {
      config.showNavigationArrows = false;
      config.showNavigationIndicators = false;
      this.langService.getCurrentLanguage().subscribe( res => {
        this.currentLang = res;
        this.getCategories();
        this.getTopSalableItems();
      });
       const tagInfos = [
      { property: 'og:title', translationKey: 'og.index.title' },
      { property: 'og:description', translationKey: 'og.index.description' },
      { property: 'og:image', translationKey: 'og.index.image' },
      
      { property: 'title', translationKey: 'og.index.title' },
      { property: 'description', translationKey: 'og.index.description' },
      { property: 'image', translationKey: 'og.index.image' }
    ];
    updateMetaTags(this.translate, this.meta, tagInfos);
    }

  ngOnInit(): void {
    const tag = this.document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    this.document.body.appendChild(tag);
    this.document.querySelector('div.carousel-indicators button[role="tab"]')?.setAttribute('aria-label', 'Carousel indicators');
    setTimeout(() => {
      this.document.querySelector('div.carousel-indicators button[role="tab"]')?.setAttribute('aria-label', 'Carousel indicators');
    }, 1000);

    this.langService.getCurrentLanguage();
  }

  getTopSalableItems(): void {
    this.publicSaleableItemResourceService.getPublicSaleableItems$Response({
      fields: '["title", "name", "rating", "featured", "images", "image1", "category", "company_name"]',
      filters: '[["featured", "=", "true"]]',
      limit_start: 0,
      limit_page_length: 4
    }).subscribe({
      next: (res) => {
        this.topSalableItems = res.body.data;
      }
    });
  }

  getCategories(): void {
  }

  saveCategoryId(id): void {
    this.localStorageService.store('category_id', id);
  }

  openModal(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true });
  }

  signAsRseller() {
    this.router.navigate(['sign-up/reseller']);
  }

  select(activeId: string) {
    this.activeId = activeId;
  }

  selectTab(tab: string) {
    this.selectedTab = tab;
  }
}
